
const supportedAppStoreLocales = [
    "de",
    "el",
    "en",
    "es",
    "it",
    "lt",
    "nl",
    "pl",
    "ro",
    "tr",
    "hu",
];

const supportedGooglePlayLocales = [
    "ca",
    "de",
    "el",
    "en",
    "es",
    "et",
    "hr",
    "it",
    "lt",
    "nl",
    "pl",
    "ro",
    "tr",
    "hu",
];

export const getAppStoreLocale = (locale: string) => supportedAppStoreLocales.includes(locale) ? locale : "en";
export const getGooglePlayLocale = (locale: string) => supportedGooglePlayLocales.includes(locale) ? locale : "en";
